import React from 'react';

import Error from '../../components/Feedback/Error';
import PageError from '../../components/Layout/Page/PageError';
import PageContentInner from '../../components/Layout/Page/PageContentInner';
import PageContent from '../../components/Layout/Page/PageContent';
import { $l } from '../../locales';

const ErrorFallback = () => {
  const redirectToHome = () => {
    window.location.href = '/';
  };

  return (
    <PageError>
      <PageContent>
        <PageContentInner height="full">
          <Error
            title={$l('ERROR_PAGE.SOMETHING_WENT_WRONG')}
            description={$l('ERROR_PAGE.PROCESSING_PROBLEM')}
            icon="150--error-sign"
            action={{ text: $l('ERROR_PAGE.GO_TO_HOME'), onClick: redirectToHome }}
          />
        </PageContentInner>
      </PageContent>
    </PageError>
  );
};

export default ErrorFallback;
